export default __webpack_public_path__ + "static/HeroImage-c6099c70603e0bfe6df4e2b566250612.jpg";